import React, { useEffect, useState, useRef, MutableRefObject, useMemo } from "react";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";
import { INLINES } from "@contentful/rich-text-types";
import { Controller } from "react-hook-form";

// Components //
import FormDragAndDropInput from "../form-drag-and-drop-input/FormDragAndDropInput";
import TableSelect from "../table-select/tableSelect";
import CheckboxText from "../checkbox-text/checkboxText";
import RadioSquare from "../radio-square/radioSquare";
import RadioOptions from "../radio-options/radioOptions";
import TableSelectAdapter from "../table-select/adapter/tableSelect.adapter";
import CustomDatePicker from "../date-picker/DatePicker";
import { countryCodes } from "../../../utils/countryCodes";

// Styles //
import "./FormInput.scss";
import rawToReact from "../../../utils/rawToReact";
import CheckboxSquare from "../checkbox-square/checkboxSquare";

interface IInputForm {
    key: string;
    title: string;
    listValue : string[];
    value: string;
    nombreId: string;
    textoTerminos?: any;
    modality?: string;
    tituloBotonTerminos?: any;
    type:
    | "select"
    | "text"
    | "text-area"
    | "number"
    | "predict"
    | "date"
    | "checkbox"
    | "checkbox-parent"
    | "email"
    | "mobile"
    | "radio"
    | "hidden"
    | "drag-and-drop"
    | "checkbox-text"
    | "checkbox-group"
    | "table-select"
    | "radio-square"
    | "radio-options"
    | "one-checkbox"
    | "label"
    | "checkbox-square"
    | "datev2";
    options?: Array<any>;
    maxLength?: number;
    isError?: boolean;
    errorMessage?: string;
    setCodeType?: any;
    setCodeTheme?: any;
    setCodeTypeDoc?: any;
    gigyaAccount?: any;
    placeholder?: any;
    setInputValue: any;
    checked?: boolean;
    isRequired?: boolean;
    disabled?: boolean;
    validBirthDate?: boolean;
    tabOrder?: string;
    dateState?: any;
    ayuda?: any;
    talleresData?: any;
    icon?: any;
    iconDark?: any;
    active?: boolean;
    onToggle?: any;
    setDuration?: (value: string) => void;
    dateStateHelper?: boolean;
    setDateStateHelper?: any;
    alertMessage?: boolean;
    ageAlert?: boolean;
    maxCharacters? : number;
    register?: any;
    seccion?: string;
    control?: any;
}

//locale custom para el date picker
const myCustomLocale = {
    // months list by order
    months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ],

    // week days by order
    weekDays: [
        {
            name: "Domingo", // used for accessibility
            short: "S", // displayed at the top of days' rows
            isWeekend: true, // is it a formal weekend or not?
        },
        {
            name: "Lunes",
            short: "M",
        },
        {
            name: "Martes",
            short: "T",
        },
        {
            name: "Miercoles",
            short: "W",
        },
        {
            name: "Jueves",
            short: "T",
        },
        {
            name: "Viernes",
            short: "F",
        },
        {
            name: "Sábado",
            short: "S",
            isWeekend: true,
        },
    ],

    // just play around with this number between 0 and 6
    weekStartingIndex: 0,

    // return a { year: number, month: number, day: number } object
    getToday(gregorainTodayObject) {
        return gregorainTodayObject;
    },

    // return a native JavaScript date here
    toNativeDate(date) {
        return new Date(date.year, date.month - 1, date.day);
    },

    // return a number for date's month length
    getMonthLength(date) {
        return new Date(date.year, date.month, 0).getDate();
    },

    // return a transformed digit to your locale
    transformDigit(digit) {
        return digit;
    },

    // texts in the date picker
    nextMonth: "Siguiente Mes",
    previousMonth: "Anterior mes",
    openMonthSelector: "Abrir selección de mes",
    openYearSelector: "Abrir selección de año",
    closeMonthSelector: "Cerrar selección de mes",
    closeYearSelector: "Cerrar selección de año",
    defaultPlaceholder: "Seleccionar...",

    // for input range value
    from: "desde",
    to: "hasta",

    // used for input value when multi dates are selected
    digitSeparator: ",",

    // if your provide -2 for example, year will be 2 digited
    yearLetterSkip: 0,

    // is your language rtl or ltr?
    isRtl: false,
};
const FormInput = (props: IInputForm) => {
    const node: MutableRefObject<any> = useRef();

    const [charactersRemaining, setCharactersRemaining] = useState(170);
    const [, setError] = useState("");

    const [selectedCountryCode, setSelectedCountryCode] = useState(countryCodes[0].code);

    // Objeto que mapea los valores de nombreId a maxLength para el caso del input TEXT-AREA
    const maxLengthMap = {
        another_reason: 100,
        description: 500,
        purpose: 500,
        proyection: 500,
        titulo:100,
        descripcion: 350,
        another_reason_specific: 100,
        another_reason_socio: 100,
        specialRequirementDetail: 170,
        disabilityDetail: 170,
        description_disability: 170,
        observations: 400,
        toolSupport: 200,
        default: 400, // Valor predeterminado si nombreId no coincide con ninguno de los anteriores
    };

    const listInputWithAlert = ["dataAuthorization"];
    const listInputAgeAlert: string[] = ["birthDate"];

    const handleTextAreaChange = (event) => {
        const currentText = event.target.value;
        const currentLength = currentText.length;

        if (currentLength < maxLengthTextArea) {
            setTextValue(currentText);
            setRemainingChars(maxLengthTextArea - currentLength);
            setIsExceeded(false);
        } else {
            setTextValue(currentText.slice(0, maxLengthTextArea));
            setRemainingChars(currentLength - maxLengthTextArea);
            setIsExceeded(true);
        }

        setInputValue(nombreId, currentText, type);
    };

    const handleTextAreaRegisterChange = (event) => {
        const currentText = event.target.value;
        const currentLength = currentText.length;
        if (currentLength < maxLengthTextArea) {
            setRemainingChars(maxLengthTextArea - currentLength);
            setIsExceeded(false);
        } else {
            setRemainingChars(currentLength - maxLengthTextArea);
            setIsExceeded(true);
        }
    }

    const {
        key,
        title,
        value,
        listValue,
        nombreId,
        type,
        options,
        maxLength,
        isError,
        errorMessage,
        placeholder,
        textoTerminos,
        tituloBotonTerminos,
        setInputValue,
        modality,
        checked,
        isRequired,
        disabled,
        tabOrder,
        dateState,
        talleresData,
        icon,
        iconDark,
        active,
        onToggle,
        setDuration,
        ayuda,
        dateStateHelper,
        setDateStateHelper,
        alertMessage,
        ageAlert,
        maxCharacters,
        register,
        seccion,
        control = {},
    } = props;

    const [isActive, setActiveSelect] = useState(false);
    const [isRadioOtherChecked, setIsRadioOtherChecked] = useState(false);
    const [radioOtherValue, setRadioOtherValue] = useState("");
    const [selectedDay, setSelectedDay] = useState(dateState);
    const { document } = useBrowserMode();
    const [dateChanged, setDateChanged] = useState<boolean>(false);
    const [inputIsError, setInputIsError] = useState(false);
    const [isExceeded, setIsExceeded] = useState(false);
    const [textValue, setTextValue] = useState("");
    const maxLengthTextArea = maxLengthMap[nombreId] || maxLengthMap["default"];
    const [remainingChars, setRemainingChars] = useState(maxLengthTextArea);



    useEffect(() => {
        if (type == "radio") {
            if (
                (options || [])
                    .map((option) => {
                        return option.split("#")[0].split(":")[0] || option;
                    })
                    .includes(value)
            ) {
                setRadioOtherValue("");
                setIsRadioOtherChecked(false);
            } else {
                if (value != "") {
                    setRadioOtherValue(value);
                }
            }
        }

        if (type === "date" && !dateChanged) {
            setSelectedDay(value);
        }
    }, [value]);

    const handleClickOutside = (e) => {
        if (node.current.contains(e.target)) {
            return;
        } else {
            setActiveSelect(false);
        }
    };

    useEffect(() => {
        if (isActive) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isActive]);

    useEffect(() => {
        const datePick = document.querySelector(".input-date-picker");
        datePick?.setAttribute("tabIndex", "8");
    }, []);


    const handleKeyDown = (e) => {
        if (
            e.key === "ArrowUp" ||
            e.key === "ArrowDown" ||
            e.keyCode === 110 ||
            e.keyCode === 190
        )
            e.preventDefault();
    };

    const shouldValidateInputMinLength = () => {
       const inputsName = ["whatsAppNumber", "auxNumber"]
       return inputsName.includes(nombreId)
    };

    const inputTypeComponent = () => {
        switch (type) {
            case "select":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input__form__title"}
                            htmlFor={type + "_" + nombreId}
                        >
                            {title}
                        </label>
                        {register ? 
                            <select
                                className="a-input__form a-input__form-select"
                                id={type + "_" + nombreId}
                                ref={node}
                                disabled={disabled}
                                tabIndex={0}
                                {...(register ? register(nombreId, { required: true }) : {})}
                            >
                                <>
                                    <option
                                        className="a-input__form a-input__form-select"
                                        key={0}
                                        value=""
                                    >
                                        {placeholder}
                                    </option>
                                    {(options || []).map((option, index) => {
                                        return (
                                            <option
                                                className="a-input__form a-input__form-select"
                                                key={index}
                                                value={option}
                                            >
                                                {option.indexOf("--") > -1
                                                    ? option.split("--")[1]
                                                    : option}
                                            </option>
                                        );
                                    })}
                                </>
                            </select>
                        :
                            <select
                                className={`a-input__form a-input__form-select ${ !value ? "empty" : ""  }`}
                                id={type + "_" + nombreId}
                                ref={node}
                                value={value}
                                onChange={(e) =>
                                    setInputValue(nombreId, e.target.value, type)
                                }
                                disabled={disabled}
                                tabIndex={0}
                                aria-labelledby={"title-" + nombreId}
                            >
                                <>
                                    <option
                                        className="a-input__form a-input__form-select"
                                        key={0}
                                        value=""
                                    >
                                        {placeholder ? placeholder : "Selecciona"}
                                    </option>
                                    {(options || []).map((option, index) => {
                                        if (typeof option === "object") {
                                            return (
                                                <option
                                                    className="a-input__form a-input__form-select"
                                                    key={index}
                                                    value={option.id}
                                                >
                                                    {option.desc}
                                                </option>
                                            );
                                        }

                                        return (
                                            <option
                                                className="a-input__form a-input__form-select"
                                                key={index}
                                                value={option}
                                            >
                                                {option.indexOf("--") > -1
                                                    ? option.split("--")[1]
                                                    : option}
                                            </option>
                                        );
                                    })}
                                </>
                            </select>
                        }
                    </>
                );
            case "email":
            case "text":
                return (
                    <>
                        {register && seccion && (
                            <label
                                id={"section-" + nombreId}
                                className="a-input__form__title a-input__form__title--margin"
                            >
                                {seccion}
                            </label>
                        )}
            
                        <label
                            id={"title-" + nombreId}
                            className="a-input__form__title"
                            htmlFor={"input-" + nombreId}
                        >
                            {title}
                        </label>
                        {textoTerminos && (
                            <span className="a-input__form__texto-terminos">
                                {rawToReact(textoTerminos.raw, contentfulRenderOptions)}
                            </span>
                        )}
                        {register && ayuda && (
                            <span className="a-input__form__texto-ayuda">{ayuda}</span>
                        )}
            
                        <input
                            className={`a-input__form__field${isError ? " a-input__form__field--error" : ""}`}
                            id={"input-" + nombreId}
                            name={nombreId}
                            type={type}
                            aria-labelledby={"title-" + nombreId}
                            aria-invalid={isError}
                            placeholder={placeholder}
                            {...(register
                                ? type === "email"
                                    ? register(nombreId, {
                                            required: isRequired ? "El correo es obligatorio" : false,
                                            pattern: {
                                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                                message: "Correo inválido",
                                            },
                                        })
                                    : register(nombreId, { required: isRequired })
                                : {
                                        value: value,
                                        maxLength:
                                            nombreId === "idNum"
                                                ? 20
                                                : nombreId === "ruralDistrict"
                                                ? 50
                                                : 40,
                                        onChange: (e) => setInputValue(nombreId, e.target.value, type),
                                        disabled: disabled,
                                    })}
                        />
                    </>
                );    
            case "mobile":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className="a-input__form__title"
                            htmlFor={"input-" + nombreId}
                        >
                            {title}
                        </label>
            
                        {textoTerminos && (
                            <span className="a-input__form__texto-terminos">
                                {rawToReact(textoTerminos.raw, contentfulRenderOptions)}
                            </span>
                        )}
                        <input
                            className={`a-input__form__field${inputIsError ? " a-input__field--error" : ""}`}
                            id={"input-" + nombreId}
                            name={nombreId}
                            type="text"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            maxLength={10}
                            aria-labelledby={"title-" + nombreId}
                            aria-invalid={inputIsError}
                            aria-describedby={inputIsError ? "error-" + nombreId : undefined}
                            value={value}
                            onChange={(e) => {
                                const sanitizedValue = e.target.value.replace(/\D/g, ""); // Solo números
                                setInputValue(nombreId, sanitizedValue, type);
            
                                // Validar longitud de 10 dígitos
                                setInputIsError(sanitizedValue.length !== 10);
                            }}
                            disabled={disabled}
                            placeholder={placeholder}
                        />      
                        {/* Mensaje de error */}
                        {inputIsError && (
                            <span id={"error-" + nombreId} className="a-input__form__error-message">
                                * El número debe tener 10 dígitos.
                            </span>
                        )}
                    </>
                );
            case "number":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input__form__title"}
                            htmlFor={"input-" + nombreId}
                        >
                            {title}
                        </label>
                        {textoTerminos && (
                            <span className="a-input__form__texto-terminos">
                                {rawToReact(textoTerminos.raw, contentfulRenderOptions)}
                            </span>
                        )}
                        {ayuda && (
                            <span className="a-input__form__texto-ayuda">
                                {ayuda}
                            </span>
                        )}
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            {/* SOLO para contactNumber y aditionalContactNumber */}
                            {["contactNumber", "aditionalContactNumber"].includes(nombreId) ? (
                                <>
                                    {countryCodes.find(c => c.code === selectedCountryCode) && (
                                        <img
                                            src={countryCodes.find(c => c.code === selectedCountryCode).icon}
                                            alt={countryCodes.find(c => c.code === selectedCountryCode).name}
                                            style={{ width: 20, height: 14, marginRight: 6, verticalAlign: "middle" }}
                                        />
                                    )}
                                    <select
                                        {...register(
                                            nombreId === "contactNumber" ? "countryCode" : "aditionalCountryCode",
                                            { required: true }
                                        )}
                                        value={selectedCountryCode}
                                        onChange={e => {
                                            setSelectedCountryCode(e.target.value);
                                        }}
                                        style={{ height: "40px", fontSize: "16px" }}
                                    >
                                        {countryCodes.map((country) => (
                                            <option key={country.code} value={country.code}>
                                                {country.flag} {country.code}
                                            </option>
                                        ))}
                                    </select>
                                    <input
                                        className={`a-input__form__field${(inputIsError || isError) ? " a-input__field--error" : ""}`}
                                        id={"input-" + nombreId}
                                        name={nombreId}
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={10}
                                        aria-labelledby={"title-" + nombreId}
                                        aria-invalid={inputIsError}
                                        placeholder={placeholder}
                                        {...register(nombreId, {
                                            required: isRequired,
                                            pattern: {
                                                value: /^[0-9]{7,10}$/,
                                                message: "Solo números (7 a 10 dígitos)",
                                            },
                                        })}
                                    />
                                </>
                            ) : (
                                // Para los demás casos, se mantiene el comportamiento original
                                <input
                                    className={`a-input__form__field${(inputIsError || isError) ? " a-input__form__field--error" : ""}`}
                                    id={"input-" + nombreId}
                                    name={nombreId}
                                    type={(register && maxCharacters) ? "text" :"number"}
                                    onKeyDown={handleKeyDown}
                                    onWheel={(e) => e.currentTarget.blur()}
                                    placeholder={placeholder}
                                    aria-labelledby={"title-" + nombreId}
                                    aria-invalid={inputIsError}
                                    maxLength={(register && maxCharacters) ? maxCharacters.toString() : "" }
                                    {...(register
                                        ? register(nombreId, { required: isRequired, pattern: (register && maxCharacters)&&{
                                            value: /^\+?[0-9]*$/,
                                            message: 'Solo números y opcionalmente un + al inicio',
                                        },
                                        minLength: (register && maxCharacters && shouldValidateInputMinLength()) && maxCharacters,
                                       })
                                        : {
                                            value: value,
                                            onChange: (e) => {
                                                const inputValue = e.target.value;

                                                if (["mobile", "auxNumber", "cellphone", "additionalCellphone"].includes(nombreId)) {
                                                    setInputIsError(inputValue.length < 10);
                                                    if (inputValue.length > 10) {
                                                        setInputValue(nombreId, inputValue.slice(0, 10), type);
                                                        return;
                                                    }
                                                } else if (nombreId === "phone") {
                                                    setInputIsError(inputValue.length < 7);
                                                    if (inputValue.length > 7) {
                                                        setInputValue(nombreId, inputValue.slice(0, 7), type);
                                                        return;
                                                    }
                                                } else if (["contactNumber", "aditionalContactNumber"].includes(nombreId)) {
                                                    if (inputValue.length > 10) {
                                                        setInputValue(nombreId, inputValue.slice(0, 10), type);
                                                        return;
                                                    }
                                                    setInputValue(nombreId, `${selectedCountryCode}${inputValue}`, type);
                                                } else {
                                                    if (inputValue.length > 13) {
                                                        setInputValue(nombreId, inputValue.slice(0, 13), type);
                                                        return;
                                                    }
                                                }
                                                setInputValue(nombreId, inputValue, type);

                                            },
                                            disabled: disabled,
                                        })}
                                />
                            )}
                        </div>

                        {(inputIsError || isError) && (
                            <span className="a-input__form__error-message">
                                * El número no es válido.
                            </span>
                        )}
                    </>
                );
            case "text-area":
                return (
                    <>
                    <label id={"title-" + nombreId} className={"a-input__form__title"}>
                        {title}
                    </label>
                    {textoTerminos && (
                        <span className="a-input__form__texto-terminos">
                            {rawToReact(textoTerminos.raw, contentfulRenderOptions)}
                        </span>
                    )}
                    {ayuda && <span className="a-input__form__texto-ayuda">{ayuda}</span>}
                    <div className="a-input__form__character-count">
                        {isExceeded ? (
                            <div className="a-input__form__character-count__exceeded">
                                <p>Tienes máximo {maxLengthTextArea} caracteres: </p>
                                <div style={{ color: "var(--alert-error)" }}>
                                * Has superado el límite de caracteres -{remainingChars}
                                </div>
                            </div>
                        ) : (
                            <p>
                                Tienes máximo {maxLengthTextArea} caracteres. Restantes:{" "}
                                <span>{remainingChars}</span>
                            </p>
                        )}
                    </div>
                    {register? 
                        <textarea
                            className={`a-input__form__field${isExceeded ? " a-input__form__field--error" : ""}`}
                            id={"text-area-" + nombreId}
                            name={title}
                            disabled={disabled}
                            rows={5}
                            cols={50}
                            {...(register ? register(nombreId, { required: true }) : {})}
                            onChange={(event) => {
                                register(nombreId).onChange(event);
                                handleTextAreaRegisterChange(event);
                            }}
                            maxLength={maxCharacters}
                            placeholder={register ? placeholder : ""}
                        />
                    :
                        <textarea
                            className={`a-input__form__field${isExceeded ? " a-input__form__field--error" : ""}`}
                            id={"text-area-" + nombreId}
                            name={title}
                            value={textValue}
                            onChange={handleTextAreaChange}
                            disabled={disabled}
                            tabIndex={0}
                            rows={5}
                            cols={50}
                            placeholder={placeholder}
                            aria-label={nombreId}
                        />
                    }
                </>
                );
            case "date":
                let date = new Date();
                const currentYear = date.getFullYear();
                const genericRef = useRef<HTMLElement>(null);
                const maximumDate = {
                    year: currentYear,
                    month: date.getMonth() + 1,
                    day: date.getDate(),
                };
                
                // Inicializar con el valor existente (este es un punto clave para la corrección)
                const initialValue = value || ""; // Usar el valor que viene de props
                
                // Preparar el estado inicial para inputDate basado en el valor existente
                const initialInputDate = useMemo(() => {
                    if (initialValue && typeof initialValue === 'string') {
                        const parts = initialValue.split("-");
                        if (parts.length === 3) {
                            return `${parts[0]}/${parts[1]}/${parts[2]}`;
                        }
                    }
                    return "";
                }, []);
                
                // Estado para manejar el valor del input
                const [inputDate, setInputDate] = useState(initialInputDate);
                
                // Preparar el estado inicial para selectedDay basado en el valor existente
                const initialSelectedDay = useMemo(() => {
                    if (initialValue && typeof initialValue === 'string') {
                        const parts = initialValue.split("-");
                        if (parts.length === 3) {
                            return {
                                day: parseInt(parts[0]),
                                month: parseInt(parts[1]),
                                year: parseInt(parts[2])
                            };
                        }
                    }
                    return null;
                }, []);

                const datePickerRef = useRef(null);

                // En tu componente, añade esto antes del return:
                useEffect(() => {
                    if (datePickerRef.current) {
                        const inputElement = datePickerRef.current.querySelector('input');
                        if (inputElement) {
                            inputElement.setAttribute('tabindex', '0');
                        }
                    }
                }, []);
                
                // Estado para manejar el día seleccionado
                const [selectedDay, setSelectedDay] = useState<{
                    day: number;
                    month: number;
                    year: number;
                } | null>(initialSelectedDay);
                
                // Estado para controlar el enfoque del input
                const [isFocused, setIsFocused] = useState(false);

                // Efecto para actualizar los estados cuando cambia el valor desde props
                useEffect(() => {
                    if (value && typeof value === 'string' && !dateChanged) {
                        const parts = value.split("-");
                        if (parts.length === 3) {
                            const formattedDate = `${parts[0]}/${parts[1]}/${parts[2]}`;
                            setInputDate(formattedDate);
                            setSelectedDay({
                                day: parseInt(parts[0]),
                                month: parseInt(parts[1]),
                                year: parseInt(parts[2])
                            });
                        }
                    }
                }, [value]);

                useEffect(() => {
                    if (dateStateHelper) {
                        // Limpia ambos estados locales
                        setInputDate("");
                        setSelectedDay(null);
                        setDateChanged(false); // Si tienes este estado
                        setDateStateHelper(false); // Importante: resetear el helper
                    }
                }, [dateStateHelper]);

                const handleDateChange = (choosenDate) => {
                    setSelectedDay(choosenDate);
                    setInputDate(`${choosenDate.day}/${choosenDate.month}/${choosenDate.year}`);
                    setDateChanged(true);
                    setInputValue(
                        nombreId,
                        `${choosenDate.day}-${choosenDate.month}-${choosenDate.year}`,
                        type
                    );
                };

                const handleInputBlur = () => {
                    const parts = inputDate.split("/");
                    if (parts.length === 3) {
                        const [day, month, year] = parts.map(Number);
                        
                        // Validate date parts
                        if (
                            day && month && year &&
                            day >= 1 && day <= 31 &&
                            month >= 1 && month <= 12 &&
                            year >= 1900 && year <= currentYear
                        ) {
                            const parsedDate = { day, month, year };
                            setSelectedDay(parsedDate);
                            setDateChanged(true);
                            setInputValue(nombreId, `${day}-${month}-${year}`, type);
                            setInputIsError(false);
                            return;
                        }
                    }
                    
                    // Invalid date
                    if (inputDate.trim()) {
                        setInputDate("");
                        setSelectedDay(null);
                    }
                    setInputIsError(!inputDate.trim());
                };

                const handleDateInput = (e: React.ChangeEvent<HTMLInputElement>) => {
                    let input = e.target.value.replace(/\D/g, ''); // Elimina caracteres no numéricos
                    let formattedInput = "";
                
                    // Para el día (primeros 2 dígitos)
                    if (input.length <= 2) {
                        formattedInput = input;
                    } 
                    // Cuando ya hay 2 dígitos para el día, añade el separador
                    else if (input.length > 2) {
                        let day = input.slice(0, 2);
                        day = parseInt(day) > 31 ? "31" : day;
                        formattedInput = day + "/";
                
                        // Para el mes (siguientes 2 dígitos)
                        if (input.length <= 4) {
                            formattedInput += input.slice(2);
                        } else {
                            let month = input.slice(2, 4);
                            month = parseInt(month) > 12 ? "12" : month;
                            formattedInput += month + "/";
                
                            // Para el año (últimos 4 dígitos)
                            if (input.length > 4) {
                                let year = input.slice(4, 8);
                                year = parseInt(year) > currentYear ? currentYear.toString() : year;
                                formattedInput += year;
                            }
                        }
                    }
                
                    setInputDate(formattedInput);
                };

                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input__form__title"}
                        >
                            {title}
                        </label>
                        {register ?                            
                            <Controller
                                control={control}
                                name={nombreId}
                                rules={{ 
                                    required: "* Pregunta obligatoria", 
                                    validate: (value) => (value && value !== "")
                                }}
                                render={({ field: { onChange, onBlur, value, ref } }) => (
                                    <DatePicker
                                        inputClassName="input-date-picker"
                                        calendarClassName="custom-datepicker-calendar"
                                        locale={myCustomLocale}
                                        value={selectedDay}
                                        inputPlaceholder={"DD/MM/AAAA"}
                                        onChange={(e) => {
                                            onChange(`${e?.day}-${e?.month}-${e?.year}`); 
                                            setInputDate(`${e?.day}/${e?.month}/${e?.year}`);
                                            setDateChanged(true);
                                        }}
                                        colorPrimary={"#ee2b7b"}
                                        maximumDate={maximumDate}
                                        renderInput={({ ref }) => (
                                            <div className="input-wrapper">
                                                <input
                                                    ref={ref as React.RefObject<HTMLInputElement>}
                                                    className="input-date-picker"
                                                    value={inputDate}
                                                    onChange={(e)=> {
                                                        handleDateInput(e); 
                                                        onChange(e.target.value.replace(/\//g, "-"));
                                                    }}
                                                    onBlur={onBlur}
                                                    onFocus={() => setIsFocused(true)}
                                                    placeholder={placeholder}
                                                />
                                                {!inputDate && !isFocused && (
                                                    <img 
                                                        className="calendar-placeholder" 
                                                        src="https://images.ctfassets.net/203frbsx1z3n/2fdROCh05kuVtBzsmgCzPp/55c6486edd19b59d646231c9a54cf4e2/calendario.svg" 
                                                        alt="Calendario"/>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                            />
                        :
                            <div ref={datePickerRef}>

                                <DatePicker
                                    tabIndex={0}
                                    inputClassName="input-date-picker"
                                    calendarClassName="custom-datepicker-calendar"
                                    locale={myCustomLocale}
                                    value={selectedDay}
                                    inputPlaceholder={"DD/MM/AAAA"}
                                    onChange={handleDateChange}
                                    colorPrimary={"#ee2b7b"}
                                    maximumDate={maximumDate}
                                    renderInput={({ ref }) => (
                                        <div className="input-wrapper">
                                            <input
                                                ref={ref as React.RefObject<HTMLInputElement>}
                                                className="input-date-picker"
                                                value={inputDate}
                                                onChange={handleDateInput}
                                                onBlur={() => {
                                                    setIsFocused(false);
                                                    handleInputBlur();
                                                }}
                                                onFocus={() => setIsFocused(true)}
                                                placeholder={placeholder}
                                                tabIndex={0}
                                                aria-label={nombreId}
                                                aria-required="true"
                                                aria-invalid={inputIsError}
                                                aria-describedby={inputIsError ? "error-message" : undefined}
                                            />
                                            {(
                                                <img 
                                                    className="calendar-placeholder" 
                                                    src="https://images.ctfassets.net/203frbsx1z3n/2fdROCh05kuVtBzsmgCzPp/55c6486edd19b59d646231c9a54cf4e2/calendario.svg" 
                                                    alt="Calendario"
                                                    tabIndex={-1}
                                                />
                                            )}
                                        </div>
                                    )}
                                />
                            </div>
                        }
                        
                        {/* toast para el campo de fecha de nacimiento */}
                        {ageAlert && listInputAgeAlert.includes(nombreId) && (
                            <div className="o-form-ruta-ideal__form__fcontainer__advertiser">
                                <img src={icon.file.url} alt="icono-información"/>
                                <p>{errorMessage}</p>
                            </div>
                        )}
                        {inputIsError && (
                            <span className="a-input__form__error-message">
                            * Pregunta obligatoria
                        </span>
                        )}
                    </>
                );
            case "checkbox":
                return (
                    <>
                        <label
                            id={"title-" + nombreId}
                            className={"a-input__form__title"}
                        >
                            {title}
                        </label>
                        <div style={{ display: "flex", alignItems: register ? "flex-start":"" }}>
                            <input
                                className={`${isError
                                    ? " a-input__form__field--error"
                                    : ""
                                    }`}
                                type="checkbox"
                                id={nombreId}
                                defaultChecked={checked}
                                checked={checked}
                                onChange={(e) =>
                                    setInputValue(
                                        nombreId,
                                        e.target.checked,
                                        type
                                    )
                                }
                                disabled={disabled}
                                tabIndex={0}
                                {...(register ? register(nombreId, { required: true }) : {})}
                            />
                            <span style={{ paddingLeft: "10px" }}>
                                {tituloBotonTerminos}
                            </span>
                        </div>
                    </>
                );
            case "radio":
                return (
                    <>
                        {placeholder && (<span className="a-input__form__radioLabel">{placeholder}</span>)}
                        <label
                            id={"title-" + nombreId}
                            className={"a-input__form__title"}
                        >
                            {title && title.includes(":") ? (
                                <>
                                    {title.replace(":", "")} {rawToReact(textoTerminos, {
                                        ...contentfulRenderOptions,
                                        renderNode: {
                                            [INLINES.HYPERLINK]: ({ data }: any, children) => (
                                                <a
                                                    href={data.uri}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "var(--color-magenta-white)", fontWeight: "bold" }}
                                                >
                                                    {children}
                                                </a>
                                            ),
                                        },
                                    })}
                                </>
                            ) : (
                                title
                            )}
                        </label>
            
                        {textoTerminos && (
                            <span className="a-input__form__texto-terminos">
                                {rawToReact(textoTerminos.raw, {
                                    ...contentfulRenderOptions,
                                    renderNode: {
                                        [INLINES.HYPERLINK]: ({ data }: any, children) => (
                                            <a
                                                href={data.uri}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: "var(--color-magenta-white)" }}
                                            >
                                                {children}
                                            </a>
                                        ),
                                    },
                                })}
                            </span>
                        )}
            
                        {ayuda && (
                            <span className="a-input__form__texto-ayuda">
                                {ayuda}
                            </span>
                        )}
            
                        <div className="radio-container" id={nombreId} role="radiogroup" aria-labelledby={"title-" + nombreId}>
                            {(options || []).map((option, index) => {
                                const uniqueId = `${nombreId}_${option.replace(/\s+/g, '_')}`;
            
                                return (
                                    <>
                                        <div key={uniqueId} className="radio-options">
                                            <input
                                                type="radio"
                                                id={uniqueId}
                                                name={nombreId}
                                                value={option ?? ""}
                                                defaultChecked={option == props.value || isRadioOtherChecked}
                                                onChange={(e) => {
                                                    if (option == "Otro") {
                                                        if (nombreId === "infoAccess") {
                                                            setInputValue(nombreId, option, type);
                                                            setIsRadioOtherChecked(false);
                                                        } else {
                                                            setInputValue(nombreId, radioOtherValue, type);
                                                            setIsRadioOtherChecked(true);
                                                        }
                                                    } else {
                                                        setInputValue(nombreId, e.target.value, type);
                                                        setIsRadioOtherChecked(false);
                                                    }
                                                }}
                                                tabIndex={0}  // Garantiza que sea tabulable
                                                aria-label={option}  // Mejora accesibilidad
                                                role="radio"  // Agrega semántica correcta
                                                {...(register && nombreId !== "dataAuthorization" ? register(nombreId, { required: true }) : {})}
                                                {...(register && nombreId.startsWith('dataAuthorization') && nombreId !== 'dataAuthorizationImage' ? register(nombreId, { required: true, validate: (value) => value.includes("Sí") }) : {})}
                                            />
                                            <label htmlFor={uniqueId} id={`${uniqueId}_label`}>
                                                {option !== "Otro" ? (
                                                    option.includes(" - ") ? (
                                                        <>
                                                            <strong>{option.split(" - ")[0]}</strong>
                                                            <p>{option.split(" - ")[1]}</p>
                                                        </>
                                                    ) : (
                                                        option
                                                    )
                                                ) : (
                                                    <>
                                                        {option}
                                                        <input
                                                            className={`bordered-radio__other-input ${isRadioOtherChecked ? "show" : ""}`}
                                                            type="text"
                                                            id={`${uniqueId}_other`}
                                                            name={nombreId}
                                                            value={radioOtherValue}
                                                            disabled={!isRadioOtherChecked}
                                                            onChange={(e) => {
                                                                setInputValue(nombreId, e.target.value, type);
                                                                setRadioOtherValue(e.target.value);
                                                            }}
                                                            placeholder={"¿Cuál?"}
                                                        />
                                                    </>
                                                )}
                                            </label>
                
                                        </div>
                                        {alertMessage && listInputWithAlert.includes(nombreId) && option.includes("No") && (
                                            <div className="a-input__form__toast-advertiser">
                                                <div className="toast-advertiser__img">
                                                    <img src={icon.file.url} alt="icono-error" />
                                                </div>
                                                <div className="toast-advertiser__description">
                                                    <p>{errorMessage}</p>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                        </div>
                    </>
                );
            case "hidden":
                return (
                    <input
                        type={type}
                        id={"input-" + nombreId}
                        name={title}
                        value={value}
                    />
                );
            case "drag-and-drop":
                return (
                    <>
                        <FormDragAndDropInput
                            setInputValue={setInputValue}
                            nombreId={nombreId}
                            type={type}
                        />
                    </>
                );
            case "table-select":
                return (
                    <>
                        <TableSelect
                            setInputValue={setInputValue}
                            title={title}
                            auxText={ayuda}
                            description={textoTerminos}
                            nombreId={nombreId}
                            type={type}
                            content={TableSelectAdapter(talleresData)}
                            setDuration={setDuration}
                        />
                    </>
                );
            case "checkbox-square":
                return (
                    <>
                        <CheckboxSquare
                            setInputValue={setInputValue}
                            nombreId={nombreId}
                            type={type}
                            options={options}
                            values={listValue}
                            modality={modality}
                            maxCharacters={maxCharacters}
                        />
                    </>
                )
            case "checkbox-group":
                return (
                    <>
                        <label id={"title-" + nombreId} className={"a-input__form__title"} htmlFor={nombreId}>
                            {title}
                        </label>
                        {ayuda && (
                            <span className="a-input__form__texto-ayuda">
                                {ayuda}
                            </span>
                        )}
                        <div className="checkbox-container" id={nombreId} role="group" aria-labelledby={"title-" + nombreId}>
                            {(options || []).map((option, index) => {
                                const optionLabel = option.label || option;
                                const optionValue = option.value || option;
                                const isSelected = Array.isArray(props.value) && props.value.includes(optionValue);
            
                                let displayLabel;
                                if (typeof optionLabel === "string") {
                                    // Encuentra el primer caracter especial y su posición
                                    const specials = ["/", "-", "*", ":"];
                                    let firstSpecial: string | null = null;
                                    let firstIndex = Infinity;
                                    specials.forEach(char => {
                                        const idx = optionLabel.indexOf(char);
                                        if (idx !== -1 && idx < firstIndex) {
                                            firstSpecial = char;
                                            firstIndex = idx;
                                        }
                                    });

                                    if (firstSpecial === "/") {
                                        // Para el caso de la barra
                                        const parts = optionLabel.split("/");
                                        displayLabel = (
                                            <>
                                                {parts[0]}
                                                <strong>{parts[1]}</strong>
                                                {parts[2] && parts.slice(2).join("/") /* Por si hay más barras */}
                                            </>
                                        );
                                    } else if (firstSpecial === "-") {
                                        // Para el caso del guion
                                        const parts = optionLabel.split(" - ");
                                        displayLabel = (
                                            <>
                                                <strong>{parts[0]}</strong>
                                                {parts[1] ? ` - ${parts[1]}` : ""}
                                            </>
                                        );
                                    } else if (firstSpecial === "*") {
                                        // Para el caso del asterisco
                                        displayLabel = (
                                            <>
                                                {optionLabel.split("*").map((part, idx, arr) => (
                                                    <React.Fragment key={idx}>
                                                        {part}
                                                        {idx !== arr.length - 1 && <span className="magenta-star">*</span>}
                                                    </React.Fragment>
                                                ))}
                                            </>
                                        );
                                    } else if (firstSpecial === ":") {
                                        // Para el caso de los dos puntos
                                        displayLabel = (
                                            <>
                                                {optionLabel.replace(":", "")}
                                                <span className="rich-text">
                                                    {rawToReact(textoTerminos, {
                                                        ...contentfulRenderOptions,
                                                        renderNode: {
                                                            [INLINES.HYPERLINK]: ({ data }: any, children) => (
                                                                <a
                                                                    href={data.uri}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ color: "var(--color-magenta-white)" }}
                                                                >
                                                                    {children}
                                                                </a>
                                                            ),
                                                        },
                                                    })}
                                                </span>
                                            </>
                                        );
                                    } else {
                                        displayLabel = optionLabel;
                                    }
                                } else {
                                    displayLabel = optionLabel;
                                }
            
                                // Generar un id único para cada checkbox
                                const uniqueId = `${nombreId}_${optionValue.replace(/\s+/g, '_')}`;
            
                                return (
                                    <div key={index} className="checkbox-option">
                                        {register ? (
                                            <Controller
                                                control={control}
                                                name={nombreId}
                                                render={({ field: { value, onChange } }) => (
                                                    <>
                                                        <input
                                                            type="checkbox"
                                                            id={uniqueId}
                                                            name={nombreId}
                                                            value={optionValue}
                                                            checked={value ? value.includes(optionValue) : false}
                                                            disabled={disabled}
                                                            tabIndex={0}  // Importante: usar 0 para orden natural de tabulación
                                                            aria-labelledby={`${uniqueId}_label`}
                                                            onChange={(e) => {
                                                                let updatedOptions = Array.isArray(value) ? [...value] : [];
            
                                                                if (e.target.checked) {
                                                                    if (optionValue === "Ninguna de las anteriores") {
                                                                        updatedOptions = ["Ninguna de las anteriores"];
                                                                    } else {
                                                                        updatedOptions = updatedOptions.filter(val => val !== "Ninguna de las anteriores");
                                                                        updatedOptions.push(optionValue);
                                                                    }
                                                                } else {
                                                                    updatedOptions = updatedOptions.filter(val => val !== optionValue);
                                                                }
                                                                onChange(updatedOptions);
                                                                setInputValue(nombreId, updatedOptions, type);
                                                            }}
                                                        />
                                                        <label 
                                                            htmlFor={uniqueId}
                                                            id={`${uniqueId}_label`}
                                                            tabIndex={0}  // Permitir que la label también sea tabulable
                                                        >
                                                            {displayLabel}
                                                        </label>
                                                    </>
                                                )}
                                            />
                                        ) : (
                                            <>
                                                <input
                                                    type="checkbox"
                                                    id={uniqueId}
                                                    name={nombreId}
                                                    value={optionValue}
                                                    checked={isSelected}
                                                    tabIndex={0}  // Importante: usar 0 para orden natural de tabulación
                                                    aria-labelledby={`${uniqueId}_label`}
                                                    onChange={(e) => {
                                                        const selectedOptions = Array.isArray(props.value) ? props.value : [];
            
                                                        if (optionValue === "Ninguna de las anteriores") {
                                                            if (e.target.checked) {
                                                                setInputValue(nombreId, [optionValue], type);
                                                            } else {
                                                                setInputValue(nombreId, selectedOptions.filter(val => val !== optionValue), type);
                                                            }
                                                        } else {
                                                            if (selectedOptions.includes("Ninguna de las anteriores")) {
                                                                setInputValue(nombreId, selectedOptions.filter(val => val !== "Ninguna de las anteriores").concat(optionValue), type);
                                                            } else {
                                                                if (e.target.checked) {
                                                                    setInputValue(nombreId, [...selectedOptions, optionValue], type);
                                                                } else {
                                                                    setInputValue(nombreId, selectedOptions.filter(val => val !== optionValue), type);
                                                                }
                                                            }
                                                        }
                                                    }}
                                                    disabled={disabled}
                                                />
                                                <label 
                                                    htmlFor={uniqueId}
                                                    id={`${uniqueId}_label`}
                                                    tabIndex={0}  // Permitir que la label también sea tabulable
                                                >
                                                    {displayLabel}
                                                </label>
                                            </>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </>
                );
            case "checkbox-text":
                return (
                    <CheckboxText
                        setInputValue={setInputValue}
                        title={tituloBotonTerminos}
                        nombreId={nombreId}
                        type={type}
                        description={textoTerminos}
                        icon={icon?.file.url}
                        iconDark={iconDark?.file.url}
                        onToggle={onToggle}
                        active={active}
                        checked={checked}
                    />
                );
            case "radio-square":
                return (
                    <>
                        <RadioSquare
                            setInputValue={setInputValue}
                            nombreId={nombreId}
                            type={type}
                            options={options}
                            value={value}
                            modality={modality}
                        />
                    </>
                );
            case "radio-options":
                if(register && control) {
                     return (
                     <Controller
                           control={control}
                           name={nombreId}
                           render={({ field }) => (
                              <RadioOptions
                                 setInputValue={(nombreId, value) => field.onChange(value)}
                                 textoTerminos={textoTerminos}
                                 titleOptions={title}
                                 nombreId={nombreId}
                                 type={type}
                                 options={options}
                                 value={field.value}
                              />
                           )}
                     />
                  );
                } else {
                  return (
                     <RadioOptions
                        setInputValue={setInputValue}
                        textoTerminos={textoTerminos}
                        titleOptions={title}
                        nombreId={nombreId}
                        type={type}
                        options={options}
                        value={value}
                     />
                  )
                }
               
            case "label":
                return (
                    <label
                        id={"title-" + nombreId}
                        className={"a-input__form__title"}
                    >
                        {title}
                    </label>
                );
            case "datev2":
                if(register) {
                     return <Controller
                        control={control}
                        name={nombreId}
                        rules={{ 
                           required: "* Pregunta obligatoria", 
                           validate: (value) => (value && value !== "")
                        }}
                        render={({ field }) => (
                              <CustomDatePicker
                                 nombreId={nombreId}
                                 value={field.value}
                                 title={title}
                                 setInputValue={(fieldNameId, value, type) => {
                                    setInputValue(fieldNameId, value, type);
                                    field.onChange(value);
                                 }}
                                 type={type}
                                 placeholder={placeholder}
                                 setDateChanged={setDateChanged}
                              />
                        )}
                     
                     />
                }else {
                  return (
                        <CustomDatePicker
                           nombreId={nombreId}
                           value={value}
                           title={title}
                           setInputValue={setInputValue}
                           type={type}
                           placeholder={placeholder}
                           setDateChanged={setDateChanged}
                        />
                     ) 
                }
            
        }
    };

    return (
        <div
            className={`a-input__form a-input__form-${type} a-input__form-${nombreId} ${isRequired ? "a-input__form--required" : ""
                } gtmFormField-${nombreId}`}
            key={key}
        >
            {inputTypeComponent()}
            {isError && (
                <span className="a-input__form__title__error">
                    {errorMessage}
                </span>
            )}
        </div>
    );
};

export default FormInput;
